import { render, staticRenderFns } from "./ArchiveMap.vue?vue&type=template&id=96b1fd68"
import script from "./ArchiveMap.vue?vue&type=script&lang=js"
export * from "./ArchiveMap.vue?vue&type=script&lang=js"
import style0 from "./ArchiveMap.vue?vue&type=style&index=0&id=96b1fd68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports